import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseElement } from '../base-element';
import { FormEvent } from '../../../crud/form/form-event.enum';
import { Languages } from '../../../enum/language';

@Component({
  selector: 'input-multilang',
  templateUrl: './multilang-input.component.html',
  styleUrls: [ './multilang-input.component.scss' ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultilangInputComponent),
    multi: true
  } ]
})
export class MultilangInputComponent extends BaseElement<string> implements OnInit {

  @Input() langs: string[] = Languages;
  @Input() type = 'text';
  @Input() placeholder: string;

  values: any = {};
  currentLang: string = 'en';
  error = '';

  ngOnInit(): void {
    this.langs.forEach(lang => this.values[lang] = '');
    if (this.channel) {
      this.channel.subscribe((event: FormEvent) => {
        if (event === FormEvent.SUBMIT) {
          if (this.form.controls[this.formControlName].invalid) {
            this.toggleInvalidClass(true);
            this.renderErrors();
          } else {
            this.toggleInvalidClass(false);
          }
        }
      });
    }

    this.form.controls[this.formControlName].valueChanges
      .subscribe(
        (value: string) => {
          try {
            const decoded = JSON.parse(value);
            this.langs.forEach(lang => {
              if (decoded[lang]) {
                this.values[lang] = decoded[lang];
              }
            });
          } catch (e) {

          }
        }
      );
  }

  onLangChange(lang: string, $event): void {
    this.form.controls[this.formControlName].patchValue(JSON.stringify(this.values));
  }

  onChange(): void {
    this.error = '';
    this.toggleInvalidClass(false);
    if (this.change) {
      this.change.emit(this.form.controls[this.formControlName].value);
    }
  }

  switchLang(lang: string) {
    this.currentLang = lang;
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }

  protected renderErrors(): void {
    this.error = '';
    if (!this.errorMessages) {
      return;
    }

    if (typeof this.errorMessages === 'string') {
      this.error = this.errorMessages;
    } else {
      const errors = this.form.controls[this.formControlName].errors;
      for (const validator of Object.keys(errors)) {
        if (errors[validator]) {
          this.error += this.errorMessages[validator] + '<br />';
        }
      }
    }
  }
}
